import { render, staticRenderFns } from "./infoInput.vue?vue&type=template&id=46e1c712&scoped=true&"
import script from "./infoInput.vue?vue&type=script&lang=js&"
export * from "./infoInput.vue?vue&type=script&lang=js&"
import style0 from "./infoInput.vue?vue&type=style&index=0&id=46e1c712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1c712",
  null
  
)

export default component.exports